// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.landlord.v1.CappsLandlordInvitationsWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  CappsLandlordInvitationsWebApiHandler_getApplicationLink,
  CappsLandlordInvitationsWebApiHandler_getApplicationLink_Path,
  CappsLandlordInvitationsWebApiHandler_getInvitedApplicants,
  CappsLandlordInvitationsWebApiHandler_getInvitedApplicants_Path,
  CappsLandlordInvitationsWebApiHandler_inviteToApply,
} from '@zg-rentals/ts-capps-client';

import type {
  GetApplicationLinkRequestDto,
  GetApplicationLinkResponseDto,
  InvitedApplicantsForListingResponseDto,
  InviteToApplyRequestDto,
  ListingAlias,
} from '@zg-rentals/ts-capps-client';

interface GetInvitedApplicantsParams {
  listingAlias: ListingAlias;
}

export type CappsLandlordInvitationsWebApiHandler_getApplicationLink_Options = UseQueryOptions<
  GetApplicationLinkResponseDto,
  unknown,
  GetApplicationLinkResponseDto,
  readonly [string, GetApplicationLinkRequestDto]
>;

const CappsLandlordInvitationsWebApiHandler_getApplicationLink_GetKey = (postData: GetApplicationLinkRequestDto) =>
  [CappsLandlordInvitationsWebApiHandler_getApplicationLink_Path, postData] as const;

export const CappsLandlordInvitationsWebApiHandler_getApplicationLink_queryOptions = (
  postData: GetApplicationLinkRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsLandlordInvitationsWebApiHandler_getApplicationLink_GetKey(postData),
    queryFn: () => CappsLandlordInvitationsWebApiHandler_getApplicationLink(postData, httpClient),
  }) as const satisfies QueryOptions;

export const useCappsLandlordInvitationsWebApiHandler_getApplicationLink = (
  postData: GetApplicationLinkRequestDto,
  {
    httpClient,
    ...options
  }: Omit<CappsLandlordInvitationsWebApiHandler_getApplicationLink_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...CappsLandlordInvitationsWebApiHandler_getApplicationLink_queryOptions(postData, { httpClient }),
    ...options,
  });
};
useCappsLandlordInvitationsWebApiHandler_getApplicationLink.getKey =
  CappsLandlordInvitationsWebApiHandler_getApplicationLink_GetKey;

export type CappsLandlordInvitationsWebApiHandler_getInvitedApplicants_Options = UseQueryOptions<
  InvitedApplicantsForListingResponseDto,
  unknown,
  InvitedApplicantsForListingResponseDto,
  readonly [string, GetInvitedApplicantsParams]
>;

const CappsLandlordInvitationsWebApiHandler_getInvitedApplicants_GetKey = (getParams: GetInvitedApplicantsParams) =>
  [CappsLandlordInvitationsWebApiHandler_getInvitedApplicants_Path, getParams] as const;

export const CappsLandlordInvitationsWebApiHandler_getInvitedApplicants_queryOptions = (
  getParams: GetInvitedApplicantsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsLandlordInvitationsWebApiHandler_getInvitedApplicants_GetKey(getParams),
    queryFn: () => CappsLandlordInvitationsWebApiHandler_getInvitedApplicants(getParams, httpClient),
  }) as const satisfies QueryOptions;

export const useCappsLandlordInvitationsWebApiHandler_getInvitedApplicants = (
  getParams: GetInvitedApplicantsParams,
  {
    httpClient,
    ...options
  }: Omit<CappsLandlordInvitationsWebApiHandler_getInvitedApplicants_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...CappsLandlordInvitationsWebApiHandler_getInvitedApplicants_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useCappsLandlordInvitationsWebApiHandler_getInvitedApplicants.getKey =
  CappsLandlordInvitationsWebApiHandler_getInvitedApplicants_GetKey;

export interface CappsLandlordInvitationsWebApiHandler_inviteToApply_Args {
  postData: InviteToApplyRequestDto;
}

export type CappsLandlordInvitationsWebApiHandler_inviteToApply_Options = UseMutationOptions<
  void,
  unknown,
  CappsLandlordInvitationsWebApiHandler_inviteToApply_Args
>;

export const useCappsLandlordInvitationsWebApiHandler_inviteToApply = ({
  httpClient,
  ...options
}: Omit<CappsLandlordInvitationsWebApiHandler_inviteToApply_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsLandlordInvitationsWebApiHandler_inviteToApply_Args) =>
      CappsLandlordInvitationsWebApiHandler_inviteToApply(args.postData, httpClient),
  });
};
